var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuMorePolicies = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18.12 20.31",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.08,4.05a.54.54,0,0,0-.43-.48C12.36,2.56,10.22,1,9.45.16a.54.54,0,0,0-.76,0C7.92,1,5.78,2.56.49,3.57a.53.53,0,0,0-.43.48C-.12,6.12-.41,16.57,8.68,20.24a1,1,0,0,0,.77,0c9.1-3.66,8.8-14.11,8.62-16.19ZM15.83,11.1a11.69,11.69,0,0,1-6.42,7.54.79.79,0,0,1-.67,0A11.67,11.67,0,0,1,2.32,11.1,19.51,19.51,0,0,1,1.5,5.31a.54.54,0,0,1,.42-.52A18.75,18.75,0,0,0,8.76,2a.54.54,0,0,1,.62,0,18.75,18.75,0,0,0,6.84,2.75.54.54,0,0,1,.42.52,19.55,19.55,0,0,1-.82,5.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.34,5.89a.34.34,0,0,0-.27-.3c-3.66-.7-5.17-1.8-5.75-2.4a.31.31,0,0,0-.24-.1.35.35,0,0,0-.24.1c-.58.59-2.09,1.69-5.75,2.4a.33.33,0,0,0-.27.3,14.46,14.46,0,0,0,.58,5.23,9.1,9.1,0,0,0,5.43,6.06.75.75,0,0,0,.26.05.8.8,0,0,0,.26-.05,9.12,9.12,0,0,0,5.43-6.06,14.46,14.46,0,0,0,.58-5.23ZM13.07,7.7,9,13.58l0,.05H9l0,0-.09.09a.81.81,0,0,1-1.11-.05L5.07,10.23A.81.81,0,0,1,6.3,9.18l2,2.58,3.41-4.93a.81.81,0,0,1,1.37.86Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuMorePolicies, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_More_Policies.b19be917.svg";
export { ForwardRef as ReactComponent };